import { PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDecodeProvider } from '../../../hooks/filters/use-encode-filter-selection';
import { AccessProvider } from '../../access/provider/access.provider';
import { AppErrorBoundaryPageComponent } from '../../error-boundary/app-error-boundary-page.component';
import { MessagePageComponent } from '../../message-page/message-page.component';
import { FilterableComponentProps } from '../interfaces/filterable-component-props.interface';

import { AppFilterStandAloneProvider } from './filter-stand-alone.provider';

interface FilterDecodeProviderProps
  extends FilterableComponentProps,
    PropsWithChildren {
  moduleId: string;
}
/**
 * Decodes filter selection from URL params and passes to filter selection receptor component.
 * This uses AppFilterStandAloneProvider which avoids to load filter selection into the global filter, that way, it won' affect other modules.
 */
export const FilterStandAloneDecodeProvider = ({
  children,
  FilterSelectionReceptorComponent,
  moduleId,
}: FilterDecodeProviderProps) => {
  // filterSelection changes only once. After URL parameter is decoded, initialFilterSelection won't change.
  const initialFilterSelection = useDecodeProvider();

  if (initialFilterSelection) {
    return (
      <AppErrorBoundaryPageComponent>
        <AccessProvider filterSelection={initialFilterSelection}>
          <AppFilterStandAloneProvider
            moduleId={moduleId}
            filterSelection={initialFilterSelection}
          >
            <FilterSelectionReceptorComponent
              filterSelection={initialFilterSelection}
            >
              {children}
            </FilterSelectionReceptorComponent>
          </AppFilterStandAloneProvider>
        </AccessProvider>
      </AppErrorBoundaryPageComponent>
    );
  } else {
    return (
      <MessagePageComponent>
        <div>
          <Spinner size="sm" /> Checking filters... Please, wait.
        </div>
      </MessagePageComponent>
    );
  }
};
